import { render, staticRenderFns } from "./BasketCard.vue?vue&type=template&id=63ab37d5&"
import script from "./BasketCard.vue?vue&type=script&lang=js&"
export * from "./BasketCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports